export default {
  login: {
    slogan: '稳健 / 快捷 / 安全',
    describe: '一站式地磅移动支付解决方案。',
    copyright: '郑州大成称重设备有限公司 @2020-2030 豫ICP备10011487号-1',
    signInTitle: '用户登录',
    accountLogin: '账号登录',
    mobileLogin: '手机号登录',
    rememberMe: '24小时免登录',
    forgetPassword: '忘记密码',
    signIn: '登录',
    signInOther: '其他登录方式',
    userPlaceholder: '用户名 / 手机 / 邮箱',
    userError: '请输入用户名',
    PWPlaceholder: '请输入密码',
    PWError: '请输入密码',
    admin: '管理员',
    user: '用户',
    mobilePlaceholder: '手机号码',
    mobileError: '请输入手机号码',
    emailPlaceholder: '邮箱',
    emailError: '请输入邮箱',
    smsPlaceholder: '短信验证码',
    smsError: '请输入短信验证码',
    smsGet: '获取验证码',
    smsSent: '已发送短信至手机号码',
    regPhoneExist: '手机号或用户名已经存在',
    regPhoneNotExist: '手机号或用户名不存在',
    checkSmsFirst: '请先校验验证码',
    noAccount: '还没有账号?',
    createAccount: '创建新账号',
    wechatLoginTitle: '二维码登录',
    wechatLoginMsg: '请使用微信扫一扫登录 | 模拟3秒后自动扫描',
    wechatLoginResult: '已扫描 | 请在设备中点击授权登录'
  },
}



// WEBPACK FOOTER //
// ./src/locales/lang/zh-CN/login.js